<template>
    <FormSearchSelect
        v-bind="$attrs"
        class="FormSelectDriver"
        :value="value"
        :label="label"
        :options="activeDrivers"
        :reduce="driver => driver.id"
        :getOptionLabel="driver => `${driver.firstName} ${driver.lastName}`"
        @input="handleInput"
    >
        <template v-if="showCreateOption" #list-header>
            <ButtonIcon icon="plus" class="block" @click="handleCreate">
                Add new
            </ButtonIcon>
        </template>
    </FormSearchSelect>
</template>

<script>
import { mapState } from 'vuex';
import DriverCreateModal from '@/components/modals/DriverCreateModal';

export default {
    name: 'FormSelectDriver',
    inheritAttrs: false,

    props: {
        value: { type: Number },
        label: { type: String, default: 'Driver' },
        showCreateOption: { type: Boolean, default: false },
    },

    data: () => ({
        initialValue: null,
    }),

    computed: {
        ...mapState('company', ['drivers']),

        activeDrivers() {
            return this.drivers.filter((driver) => {
                return driver.id === this.initialValue ? true : driver.isActive;
            });
        },
    },

    beforeMount() {
        this.initialValue = this.value;
    },

    methods: {
        handleInput(driverId) {
            this.$emit('input', driverId);
        },

        handleCreate() {
            this.$analytics.trackButtonClick(this.$options.name, 'prompt_create_driver', {
                model_type: 'driver',
                model_action: 'create_intent',
            });

            this.$modal.show(DriverCreateModal, {
                onDriverCreated: this.handleDriverCreated
            });
        },

        handleDriverCreated(newDriver) {
            this.$emit('input', newDriver.id);
        },
    },
};
</script>

<style lang="scss" scoped>
.FormSelectDriver {
    .ButtonIcon {
        justify-content: flex-start;
    }
}
</style>
